/**
 * Manual translation fallbacks for strings not covered by Transifex.
 * Used as a fallback when Transifex.live.translateText returns the original string.
 */
export const manualTranslations = {
  'Alerts in Natural Forest': {
    es: 'Alertas en el Bosque Natural',
    pt: 'Alertas em Floresta Natural',
  },
  'Alerts in Non-Forest': {
    es: 'Alertas en zonas no forestales',
    pt: 'Alertas em Áreas Não Florestais',
  },
  'Alerts in JRC Forest': {
    es: 'Alertas en el Bosque JRC',
    pt: 'Alertas na Floresta JRC',
  },
  'All Alerts': {
    es: 'Todas las alertas',
    pt: 'Todos os Alertas',
  },
  'since last TCL data update': {
    es: 'desde la última actualización de datos TCL',
    pt: 'desde a última atualização de dados TCL',
  },
  'Recent Disturbance Alerts': {
    es: 'Alertas de Perturbación Reciente',
    pt: 'Alertas de Perturbação Recente',
  },
  'Download Report': {
    es: 'Descargar Informe',
    pt: 'Baixar Relatório',
  },
  "Alerts Dashboard has moved. To view your data, open a list with Alerts analysis applied and select the 'Recent Disturbance Alerts' tab in the List Details page.":
    {
      es: "El tablero de Alertas se ha movido. Para ver sus datos, abra una lista con el análisis de Alertas aplicado y seleccione la pestaña 'Alertas de perturbación reciente' en la página de detalles de la lista.",
      pt: "O Painel de Alertas foi movido. Para ver seus dados, abra uma lista com a análise de Alertas aplicada e selecione a guia 'Alertas de perturbação recente' na página de detalhes da lista.",
    },
  'Show Lists': {
    es: 'Mostrar listas',
    pt: 'Mostrar listas',
  },
  'Welcome!': {
    es: '¡Bienvenido!',
    pt: 'Bem-vindo!',
  },
  'How to add your data': {
    es: 'Cómo agregar tus datos',
    pt: 'Como adicionar seus dados',
  },
  'Type and press Enter': {
    es: 'Escriba y presione Enter',
    pt: 'Digite e pressione Enter',
  },
  'Help Center': {
    es: 'Centro de ayuda',
    pt: 'Central de Ajuda',
  },
  'SELECT COUNTRY': {
    es: 'SELECCIONAR PAÍS',
    pt: 'SELECIONAR PAÍS',
  },
  'Draw in the map the area you want to analyze or subscribe to': {
    es: 'Dibuje en el mapa el área que desea analizar o suscribirse a',
    pt: 'Desenhe no mapa a área que você deseja analisar ou assinar',
  },
  'Start Drawing': {
    es: 'Comenzar a dibujar',
    pt: 'Iniciar desenho',
  },
  Cancel: {
    es: 'Cancelar',
    pt: 'Cancelar',
  },
  'Saved Locations': {
    es: 'Ubicaciones guardadas',
    pt: 'Locais salvos',
  },
  'All Locations': {
    es: 'Todas las ubicaciones',
    pt: 'Todos os locais',
  },
  Investment: {
    es: 'Inversión',
    pt: 'Investimento',
  },
  Commodity: {
    es: 'Producto básico',
    pt: 'Commodity',
  },
  'My Lists': {
    es: 'Mis listas',
    pt: 'Minhas listas',
  },
  'Global Forest Watch Lists': {
    es: 'Listas de Global Forest Watch',
    pt: 'Listas do Global Forest Watch',
  },
  'Shared Lists': {
    es: 'Listas compartidas',
    pt: 'Listas compartilhadas',
  },
  'Privacy Policy': {
    es: 'Política de privacidad',
    pt: 'Política de privacidade',
  },
  'Cookies Preference': {
    es: 'Preferencia de cookies',
    pt: 'Preferências de cookies',
  },
  'Terms of Use': {
    es: 'Términos de uso',
    pt: 'Termos de uso',
  },
  'License Agreement': {
    es: 'Acuerdo de licencia',
    pt: 'Contrato de licença',
  },
  'Organize lists into folders by clicking a': {
    es: 'Organiza listas en carpetas haciendo clic en un',
    pt: 'Organize listas em pastas clicando em um',
  },
  'button below.': {
    es: 'botón a continuación.',
    pt: 'botão abaixo.',
  },
  'Analysis updated': {
    es: 'Análisis actualizado',
    pt: 'Análise atualizada',
  },
  'Land Cover Dataset': {
    es: 'Conjunto de datos de cobertura terrestre',
    pt: 'Conjunto de dados de cobertura terrestre',
  },
  'JRC Global Forest Cover': {
    es: 'Cobertura forestal global JRC',
    pt: 'Cobertura florestal global JRC',
  },
  'SBTN Natural Lands': {
    es: 'Tierras naturales de SBTN',
    pt: 'Terras naturais SBTN',
  },
  'Forest Dataset': {
    es: 'Conjunto de datos forestal',
    pt: 'Conjunto de dados florestais',
  },
  'SBTN Natural Forest Loss': {
    es: 'Pérdida de bosque natural SBTN',
    pt: 'Perda de floresta natural SBTN',
  },
  'Post-2000 Forest Change': {
    es: 'Cambio Forestal Posterior al año 2000',
    pt: 'Mudança Florestal Pós-2000',
  },
  'List Map': {
    es: 'Mapa de lista',
    pt: 'Mapa da lista',
  },
  'Update Analysis': {
    es: 'Actualizar análisis',
    pt: 'Atualizar análise',
  },
  'Change Type of analysis': {
    es: 'Cambiar tipo de análisis',
    pt: 'Alterar tipo de análise',
  },
  'List diagnostic': {
    es: 'Diagnóstico de lista',
    pt: 'Diagnóstico da lista',
  },
  'Location Diagnostic': {
    es: 'Diagnóstico de ubicación',
    pt: 'Diagnóstico de localização',
  },
  'Location diagnostic': {
    es: 'Diagnóstico de ubicación',
    pt: 'Diagnóstico de localização',
  },
  'New data available': {
    es: 'Nuevos datos disponibles',
    pt: 'Novos dados disponíveis',
  },
  'Updated analysis data is available. Re-submit your list for analysis to see the latest results.':
    {
      es: 'Hay nuevos datos de análisis disponibles. Vuelva a enviar su lista para análisis y vea los últimos resultados.',
      pt: 'Novos dados de análise estão disponíveis. Reenvie sua lista para análise e veja os resultados mais recentes.',
    },
  'Re-submit': {
    es: 'Reenviar',
    pt: 'Reenviar',
  },
  'Location(s) Map': {
    es: 'Mapa de ubicación(es)',
    pt: 'Mapa de localização(ões)',
  },
  'Copy/Move': {
    es: 'Copiar/Mover',
    pt: 'Copiar/Mover',
  },
  Copy: {
    es: 'Copiar',
    pt: 'Copiar',
  },
  Download: {
    es: 'Descargar',
    pt: 'Baixar',
  },
  'Location(s) CSV': {
    es: 'CSV de ubicación(es)',
    pt: 'CSV de localização(ões)',
  },
  'Location(s) Shapefile': {
    es: 'Shapefile de ubicación(es)',
    pt: 'Shapefile de localização(ões)',
  },
  'Location(s) GeoJSON': {
    es: 'GeoJSON de ubicación(es)',
    pt: 'GeoJSON de localização(ões)',
  },
  'Downloads contain location data only; no analysis': {
    es: 'Las descargas contienen solo datos de ubicación; sin análisis',
    pt: 'Os downloads contêm apenas dados de localização; sem análise',
  },
  'Download error file CSV': {
    es: 'Descargar archivo de error CSV',
    pt: 'Baixar arquivo de erro CSV',
  },
  'Recommended to support EUDR compliance': {
    es: 'Recomendado para cumplir con el EUDR',
    pt: 'Recomendado para conformidade com o EUDR',
  },
  'Deforestation in natural forest since 2021 + additional contextual datasets': {
    es: 'Deforestación en bosque natural desde 2021 + conjuntos de datos contextuales adicionales',
    pt: 'Desmatamento em floresta natural desde 2021 + conjuntos de dados contextuais adicionais',
  },
  'Recent global integrated disturbance alerts for one time analysis.': {
    es: 'Alertas de perturbación global integrada reciente para análisis único.',
    pt: 'Alertas de perturbação global integrada recente para análise única.',
  },
  'Annual tree cover loss since 2001 + additional contextual and regional datasets': {
    es: 'Pérdida anual de cobertura arbórea desde 2001 + conjuntos de datos contextuales y regionales adicionales',
    pt: 'Perda anual de cobertura arbórea desde 2001 + conjuntos de dados contextuais e regionais adicionais',
  },
  'Recent global integrated disturbance alerts, automatically updated weekly.': {
    es: 'Alertas de perturbación global integrada reciente, actualizadas automáticamente de forma semanal.',
    pt: 'Alertas de perturbação global integrada recente, atualizadas automaticamente semanalmente.',
  },
  'Selecting Weekly Alerts will deduct from available usage. Please see our': {
    es: 'Seleccionar Alertas Semanales deducirá del uso disponible. Consulte nuestro',
    pt: 'Selecionar Alertas Semanais irá deduzir do uso disponível. Consulte nossa',
  },
  'Price Sheet': {
    es: 'Hoja de precios',
    pt: 'Tabela de preços',
  },
  'for more information.': {
    es: 'para más información.',
    pt: 'para mais informações.',
  },
  'Submit Analysis': {
    es: 'Enviar análisis',
    pt: 'Enviar análise',
  },
  'Save as Draft': {
    es: 'Guardar como borrador',
    pt: 'Salvar como rascunho',
  },
  'Save Changes': {
    es: 'Guardar cambios',
    pt: 'Salvar alterações',
  },
  'Request an account': {
    es: 'Solicitar una cuenta',
    pt: 'Solicitar uma conta',
  },
  'Got it': {
    es: 'Entendido',
    pt: 'Entendi',
  },
  'GFW Pro retires December 31, 2026': {
    es: 'GFW Pro se retira el 31 de diciembre de 2026',
    pt: 'O GFW Pro será desativado em 31 de dezembro de 2026',
  },
  'GFW Pro, including the web interface and API, is consolidating into Global Nature Watch and will retire on December 31, 2026.':
    {
      es: 'GFW Pro, incluida la interfaz web y la API, se está consolidando en Global Nature Watch y se retirará el 31 de diciembre de 2026.',
      pt: 'O GFW Pro, incluindo a interface web e a API, está sendo consolidado no Global Nature Watch e será desativado em 31 de dezembro de 2026.',
    },
  'Global Nature Watch offers two self-service transition paths.': {
    es: 'Global Nature Watch ofrece dos rutas de transición de autoservicio.',
    pt: 'O Global Nature Watch oferece dois caminhos de transição de autoatendimento.',
  },
  'Read the transition blog': {
    es: 'Lea el blog de transición',
    pt: 'Leia o blog de transição',
  },
  'and plan to': {
    es: 'y planifique',
    pt: 'e planeje',
  },
  'export your data': {
    es: 'exportar sus datos',
    pt: 'exportar seus dados',
  },
  'before then, as data will be deleted.': {
    es: 'antes de esa fecha, ya que los datos serán eliminados.',
    pt: 'antes dessa data, pois os dados serão excluídos.',
  },
  "Select which type(s) of data analysis you'd like to be available for this list. Note that analysis processing counts towards your account usage limits. See more information":
    {
      es: 'Seleccione qué tipo(s) de análisis de datos desea tener disponibles para esta lista. Tenga en cuenta que el procesamiento de análisis cuenta para los límites de uso de su cuenta. Ver más información',
      pt: 'Selecione qual(is) tipo(s) de análise de dados você gostaria de disponibilizar para esta lista. O processamento de análise conta para os limites de uso da sua conta. Veja mais informações',
    },
  Failed: {
    es: 'Fallido',
    pt: 'Falhou',
  },
  'This list has failed analysis. To receive results, resubmit this list for analysis.': {
    es: 'Esta lista no pudo ser analizada. Para recibir resultados, vuelva a enviar esta lista para análisis.',
    pt: 'Esta lista falhou na análise. Para receber resultados, reenvie esta lista para análise.',
  },
  'This list was not processed because it would have exceeded your organization\'s current usage limits. Contact our team to increase limits. After limits have been increased, click "submit for analysis" to retry.':
    {
      es: 'Esta lista no fue procesada porque excedería los límites de uso actuales de su organización. Contacte a nuestro equipo para aumentar los límites. Después de que los límites hayan sido aumentados, haga clic en "enviar para análisis" para reintentar.',
      pt: 'Esta lista não foi processada porque excederia os limites de uso atuais da sua organização. Contate nossa equipe para aumentar os limites. Depois que os limites forem aumentados, clique em "enviar para análise" para tentar novamente.',
    },
  'New ways forward as GFW Pro retires on December 31, 2026': {
    es: 'Nuevas alternativas ante el retiro de GFW Pro el 31 de diciembre de 2026',
    pt: 'Novos caminhos enquanto o GFW Pro é desativado em 31 de dezembro de 2026',
  },
  'As part of the evolution from Global Forest Watch into Global Nature Watch, we are consolidating our product suite and GFW Pro, including both the web interface and the API, will retire on December 31, 2026. Global Nature Watch offers two transition paths.':
    {
      es: 'Como parte de la evolución de Global Forest Watch hacia Global Nature Watch, estamos consolidando nuestro conjunto de productos y GFW Pro, incluidas tanto la interfaz web como la API, se retirará el 31 de diciembre de 2026. Global Nature Watch ofrece dos rutas de transición.',
      pt: 'Como parte da evolução do Global Forest Watch para o Global Nature Watch, estamos consolidando nosso conjunto de produtos e o GFW Pro, incluindo a interface web e a API, será desativado em 31 de dezembro de 2026. O Global Nature Watch oferece dois caminhos de transição.',
    },
  'Please read our blog post to learn more about these transition paths.': {
    es: 'Lea nuestra publicación en el blog para obtener más información sobre estas rutas de transición.',
    pt: 'Leia nossa postagem no blog para saber mais sobre esses caminhos de transição.',
  },
  'Please note, we will not accept requests for new accounts after November 2nd.': {
    es: 'Tenga en cuenta que no aceptaremos solicitudes de nuevas cuentas después del 2 de noviembre.',
    pt: 'Observe que não aceitaremos solicitações de novas contas após 2 de novembro.',
  },
  'Using or considering GFW Pro today? Read the': {
    es: '¿Usa o considera GFW Pro hoy? Lea la',
    pt: 'Usa ou está considerando o GFW Pro hoje? Leia o',
  },
  'transition guidance': {
    es: 'guía de transición',
    pt: 'guia de transição',
  },
  and: {
    es: 'y',
    pt: 'e',
  },
  'export your data.': {
    es: 'exporte sus datos.',
    pt: 'exporte seus dados.',
  },
  '. Both paths are self-service.': {
    es: '. Ambas rutas son de autoservicio.',
    pt: '. Ambos os caminhos são de autoatendimento.',
  },
  'As part of the evolution from Global Forest Watch into Global Nature Watch, we are consolidating our product suite and GFW Pro will retire on December 31, 2026. We recommend new users explore the alternatives now available for free across WRI:':
    {
      es: 'Como parte de la evolución de Global Forest Watch hacia Global Nature Watch, estamos consolidando nuestro conjunto de productos y GFW Pro se retirará el 31 de diciembre de 2026. Recomendamos a los nuevos usuarios explorar las alternativas ahora disponibles de forma gratuita en WRI:',
      pt: 'Como parte da evolução do Global Forest Watch para o Global Nature Watch, estamos consolidando nosso conjunto de produtos e o GFW Pro será desativado em 31 de dezembro de 2026. Recomendamos que novos usuários explorem as alternativas agora disponíveis gratuitamente na WRI:',
    },
  ', our AI-enhanced, next-generation monitoring experience in preview, and our self-hosted monitoring datasets for direct access and integration into your internal systems. To learn more, read our':
    {
      es: ', nuestra experiencia de monitoreo de próxima generación mejorada con IA en vista previa, y nuestros conjuntos de datos de monitoreo autoalojados para acceso directo e integración en sus sistemas internos. Para obtener más información, lea nuestra',
      pt: ', nossa experiência de monitoramento de próxima geração aprimorada com IA em prévia, e nossos conjuntos de dados de monitoramento auto-hospedados para acesso direto e integração em seus sistemas internos. Para saber mais, leia nossa',
    },
  'blog post': {
    es: 'publicación en el blog',
    pt: 'postagem no blog',
  },
  'outlining these alternatives for those considering GFW Pro or the GFW Pro API.': {
    es: 'que describe estas alternativas para quienes consideran GFW Pro o la API de GFW Pro.',
    pt: 'descrevendo essas alternativas para quem considera o GFW Pro ou a API do GFW Pro.',
  },
  'If those tools meet your needs, we encourage you to start there rather than requesting a GFW Pro account.':
    {
      es: 'Si esas herramientas satisfacen sus necesidades, le recomendamos comenzar por ahí en lugar de solicitar una cuenta de GFW Pro.',
      pt: 'Se essas ferramentas atendem às suas necessidades, recomendamos começar por lá em vez de solicitar uma conta do GFW Pro.',
    },
  "Please only submit this request if you have a specific, time-bound need for GFW Pro's capabilities that the alternatives cannot address, or if you need to cross-check GFW Pro metrics directly ahead of the platform's retirement. If so, please submit your request and":
    {
      es: 'Envíe esta solicitud solo si tiene una necesidad específica y limitada en el tiempo de las capacidades de GFW Pro que las alternativas no pueden cubrir, o si necesita verificar directamente las métricas de GFW Pro antes del retiro de la plataforma. Si es así, envíe su solicitud y',
      pt: 'Envie esta solicitação apenas se você tiver uma necessidade específica e limitada no tempo das capacidades do GFW Pro que as alternativas não podem atender, ou se precisar verificar diretamente as métricas do GFW Pro antes da desativação da plataforma. Se for o caso, envie sua solicitação e',
    },
  'contact our team directly': {
    es: 'contacte directamente a nuestro equipo',
    pt: 'contate nossa equipe diretamente',
  },
  'right away. We are only able to move account requests forward when we hear from you directly.': {
    es: 'de inmediato. Solo podemos avanzar con las solicitudes de cuenta cuando recibimos una respuesta directa de usted.',
    pt: 'imediatamente. Só podemos avançar com as solicitações de conta quando ouvimos de você diretamente.',
  },
};

/**
 * Returns the manual translation for the given text and language code.
 * Supports 'es' (Spanish) and 'pt' (Portuguese), with various locale formats (e.g. pt-BR, pt_BR).
 * Falls back to the original text if no translation is found.
 */
export const getManualTranslation = (text, languageCode) => {
  const translations = manualTranslations[text];
  if (!translations) {
    return text;
  }

  // Normalize language code - handle various formats like 'pt', 'pt-BR', 'pt_BR', 'pt-br'
  const normalizedCode = languageCode?.toLowerCase()?.split(/[-_]/)[0];

  if (normalizedCode === 'es') {
    return translations.es || text;
  }
  if (normalizedCode === 'pt') {
    return translations.pt || text;
  }

  return text;
};
